"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./campaignMediaBlock.scss");
const ZoomCredential_1 = __importDefault(require("../../zoomCredential/ZoomCredential"));
const switch_badge_icon_svg_1 = __importDefault(require("../../../assets/images/icons/switch-badge-icon.svg"));
const switch_certificate_icon_svg_1 = __importDefault(require("../../../assets/images/icons/switch-certificate-icon.svg"));
const campaignMediaBlockTranslations_json_1 = __importDefault(require("./campaignMediaBlockTranslations/campaignMediaBlockTranslations.json"));
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../../constants/master");
const constants_1 = require("../../../constants/constants");
const BaseSwitch_1 = __importDefault(require("../../../elementKit/baseSwitch/BaseSwitch"));
const StyledCampaignMediaBlock = styled_components_1.default.div `
  .credential-switch {
    background: ${(props) => `${props.primaryColor}33`} !important;

    .active {
      background: ${(props) => props.primaryColor} !important;
    }
  }
`;
function CampaignMediaBlock(props) {
    var _a, _b, _c, _d;
    props.addTranslation(campaignMediaBlockTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    const RectLoader = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("../../loaders/Rectangle/Rectangle"))));
    const [activeImg, setActiveImg] = (0, react_1.useState)("certificate");
    const [activeBlockWidth, setActiveBlockWidth] = (0, react_1.useState)(0);
    function getBlockWidth() {
        const block = document.getElementById("credential-media-block");
        if (block) {
            setActiveBlockWidth(block.clientWidth);
        }
    }
    const landscapeDesigns = [
        constants_1.DesignOrientation.Landscape,
        constants_1.DesignOrientation.LetterLandscape,
        constants_1.DesignOrientation.LegalSizeLandscape,
        constants_1.DesignOrientation.Ratio16_9,
    ];
    const hasLandscapeDesign = (((_a = props.campaign.design) === null || _a === void 0 ? void 0 : _a.orientation) &&
        landscapeDesigns.includes((_b = props.campaign.design) === null || _b === void 0 ? void 0 : _b.orientation)) ||
        (((_c = props.campaign.badgeDesign) === null || _c === void 0 ? void 0 : _c.orientation) &&
            landscapeDesigns.includes((_d = props.campaign.badgeDesign) === null || _d === void 0 ? void 0 : _d.orientation));
    function getZoomCredentialHeight() {
        if (props.isMobile) {
            return hasLandscapeDesign ? 253 : 370;
        }
        return hasLandscapeDesign ? 386 : 500;
    }
    (0, react_1.useEffect)(() => {
        getBlockWidth();
        window.addEventListener("resize", getBlockWidth);
        return () => {
            window.removeEventListener("resize", getBlockWidth);
        };
    }, [activeBlockWidth]);
    function getMobileCredWidth() {
        if (props.isMobile && activeBlockWidth <= 768) {
            return activeBlockWidth > 358 ? 358 : activeBlockWidth - 36;
        }
        return 546;
    }
    return (react_1.default.createElement(StyledCampaignMediaBlock, { primaryColor: config.primaryColor, containerBackgroundColor: config.containerBackgroundColor, id: "campaign-media-block" }, props.loading || props.imageLoading ? (react_1.default.createElement("div", { className: "certificate-badge-container", style: {
            minWidth: "600px",
            maxWidth: "600px",
        } },
        react_1.default.createElement(RectLoader, { radius: 10, width: 500, height: 350 }))) : (react_1.default.createElement("div", { className: `certificate-badge-container ${!hasLandscapeDesign ? "vertical-cont" : ""}` },
        props.campaign.design && !props.campaign.badgeDesign ? (react_1.default.createElement("div", { className: "certificate-badge" },
            react_1.default.createElement("div", { className: "real-img-container" },
                react_1.default.createElement("div", { className: "cert-container" },
                    react_1.default.createElement(ZoomCredential_1.default, { height: getZoomCredentialHeight(), width: getMobileCredWidth(), design: props.campaign.design, isBadge: false }))))) : null,
        !props.campaign.design && props.campaign.badgeDesign ? (react_1.default.createElement("div", { className: "certificate-badge" },
            react_1.default.createElement("div", { className: "real-img-container" },
                react_1.default.createElement("div", { className: "cert-container" },
                    react_1.default.createElement(ZoomCredential_1.default, { height: getZoomCredentialHeight(), width: getMobileCredWidth(), design: props.campaign.badgeDesign, isBadge: true }))))) : (""),
        props.campaign.design && props.campaign.badgeDesign ? (react_1.default.createElement("div", { className: "certificate-badge" },
            react_1.default.createElement("div", { className: "real-img-container" }, activeImg === "certificate" ? (react_1.default.createElement("div", { className: "cert-container" },
                react_1.default.createElement(ZoomCredential_1.default, { height: getZoomCredentialHeight(), width: getMobileCredWidth(), design: props.campaign.design, isBadge: false }))) : (react_1.default.createElement("div", { className: "cert-container" },
                react_1.default.createElement(ZoomCredential_1.default, { height: getZoomCredentialHeight(), width: getMobileCredWidth(), design: props.campaign.badgeDesign, isBadge: true })))))) : (""),
        props.campaign.design && props.campaign.badgeDesign && (react_1.default.createElement(BaseSwitch_1.default, { options: [
                {
                    icon: switch_certificate_icon_svg_1.default,
                    text: props.translate("certificate").toString(),
                    value: "certificate",
                },
                {
                    icon: switch_badge_icon_svg_1.default,
                    text: props.translate("badge").toString(),
                    value: "badge",
                },
            ], styles: {
                marginTop: "20px",
            }, isMobile: props.isMobile, value: activeImg, setValue: setActiveImg }))))));
}
exports.default = CampaignMediaBlock;
